import type { ClientShelfGame } from '../common/shelfTypes.js'

type LazyShelfGame = () => Promise<ClientShelfGame>;

const shelf: Record<string, LazyShelfGame> = {
	circleRider: () => import('./circleRider/client/index.js').then(m => m.default),
	hueHunt: () => import('./hueHunt/client/index.js').then(m => m.default),
	mirrorMirror: () => import('./mirrorMirror/client/index.js').then(m => m.default),
	tileTangle: () => import('./tileTangle/client/index.js').then(m => m.default),
	traceRace: () => import('./traceRace/client/index.js').then(m => m.default),
	auctionHouse: () => import('./auctionHouse/client/index.js').then(m => m.default),
	dotDash:      () => import('./dotDash/client/index.js').then(m => m.default),
	colorCode:    () => import('./colorCode/client/index.js').then(m => m.default),
	turfWar:      () => import('./turfWar/client/index.js').then(m => m.default),
};

export function prefetch(slug: string) {
	if (shelf[slug]) shelf[slug]();
}

export type { LazyShelfGame };
export default shelf;
